import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/saint-vs-standard-tms")({
  beforeLoad: () => {
    throw redirect({ to: "/learn/saint-vs-traditional-tms", statusCode: 301 });
  },
});
